import React, {useState, useEffect, Fragment} from 'react'
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Slide from '@mui/material/Slide';

import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';

import apiClient from "../../request/http-common";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setRedirect } from '../Auth/historySlice';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import Divider from '@mui/material/Divider';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';

import ListSubheader from '@mui/material/ListSubheader';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { CardActions } from '@mui/material';
import { Currency } from '@depay/local-currency';
import { useQuery } from 'react-query';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { setDepayTransactions } from '../../request/Analysis/hitorySlice';

import { QRCode } from 'react-qrcode-logo';
import TextField from '@mui/material/TextField';

import { CardContent } from '@mui/material';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import { useMutation } from 'react-query';
import { setFundings } from '../Wallet/walletSlice';
import SendIcon from '@mui/icons-material/Send';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import usePortfolioBalance from '../../hooks/usePortfolioBalance';
import { setRate } from '../../request/CoinRates/coinSlice';
import {
  formatUsd,
  formatCryptoAmount,
  getPriceUsd,
  isBankWallet,
  isCryptoWallet,
} from '../../utils/balanceUtils';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Receive = () => {
  const [error, setErros] = useState('');

    const navigate = useNavigate();
    const { coinRates } = usePortfolioBalance();

    const { refetch: refetchCoinRates } = useQuery(
      'receive-coin-rates',
      () => apiClient.get('/api/get-coin-rate'),
      {
        enabled: false,
        onSuccess: (res) => {
          if (res.data?.status === 'success' && Array.isArray(res.data.coin_rate)) {
            dispatch(setRate(res.data.coin_rate));
          }
        },
      }
    );

    useEffect(() => {
      if (!coinRates?.length) {
        refetchCoinRates();
      }
    }, [coinRates?.length, refetchCoinRates]);
    const user = useSelector((state) => state.user.user);
    const addresses = useSelector((state) => state.coins.addresses);
    const isAuth = useSelector((state) => state.auth.isAuthenticated);
    const [coin, setCoin] = useState('');
    const [address, setAddress] = useState('');

    const dispatch = useDispatch();
    const [amount, setAmount] = useState(null);
    const [buttonText, setbuttonText] = useState(null);
    const [amountText, setAmountText] = useState(null);
    const [open, setOpen] = React.useState(false);
    const coins = useSelector((state) => state.coins.coins);
    const [conArray, setCoinArray] = useState([]);
    const availableCoins = ['USDT', 'USDTERC20', 'USDTTRC20', 'XMR', 'XLM', 'ETH', 'TRX', 'XRP', 'BTC', 'LTC', 'BCH', 'DOGE', 'DASH', 'BNB'];

    let acceptedCoins = [];
    const loadCoins = () => {

      if (addresses.length > 0) {
        addresses.forEach(address => {
          acceptedCoins.push(address.coin_name);
          setCoinArray(acceptedCoins);
        });
      }

    }

    const { isLoading: isSendingRequest, mutate: postRequest } = useMutation(

        async () => {
          return await apiClient.post(`/api/save-funding`, {
            amount: amount,
            coin: coin.id
          });
        },
        {
          onSuccess: (res) => {
            dispatch(setFundings(res.data.fundings))
            setCoin('');
    
            localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            const event2 = new Event('processed');
            window.dispatchEvent(event2);
            setTimeout(() => {
              navigate('/account-wallet');
            }, 2000);
          },
          onError: (err) => { 
            // setCoin('');
            if (err.response?.data.length) {
              let myerror = err.response?.data || err;         
            //   setErros(myerror.errors)  
              const event2 = new Event('processed');
              window.dispatchEvent(event2); 
            }else{
              
              let errMessage = err.response?.data.message || err;     
    
              localStorage.setItem('notification', JSON.stringify({message : `${errMessage}`, 'type': 'error' }));
              const event = new Event('newMessage');
              window.dispatchEvent(event);
              const event2 = new Event('processed');
              window.dispatchEvent(event2); 
            }
                
          },
        }
      );

    useEffect(() => {
        loadCoins();
      }, []);

    const usdAmount = parseFloat(amount) || 0;
    const selectedSymbol = coin?.coin_name || '';
    const coinPriceUsd = selectedSymbol ? getPriceUsd(selectedSymbol, coinRates) : 0;
    const estimatedCoinAmount =
      usdAmount > 0 && coinPriceUsd > 0 ? usdAmount / coinPriceUsd : 0;

  return (
    <div style={{marginTop: '70px'}}>
      
      {coin === '' ?


          <Fragment>

          {addresses.length > 0 && (

      <List sx={{ width: '100%', marginTop: '20px' }}
      subheader={<ListSubheader sx={{zIndex: 0, textAlign: 'center', position: 'relative'}}>SELECT ANY PAYMENT METHOD BELOW</ListSubheader>}
      >

      {addresses.map(address => (
        
        (address.display_area === 'payments')
          
          && 
         <Fragment key={address.coin_name}>
        <ListItem alignItems="flex-start">
        <ListItemAvatar>
            <Avatar alt="Coin Name"
            src={`https://assets.coincap.io/assets/icons/${address.coin_name.toLowerCase()}@2x.png`}
            />
        </ListItemAvatar>

        <ListItemText
          primary={address.coin_name}
          secondary={
            <React.Fragment>
            </React.Fragment>
          }
        />
        <Button onClick={() => {
        setCoin(address);
        setAddress(address.address);
        // addresses.forEach(address => {
        //   if (address.coin_name === coin.coin_name) {
            
        //   }
        // });
        
        }} fullWidth={false} edge="end" size="small" color="primary" variant="contained"> 
          Deposit
        </Button> 
        
      </ListItem>
      <Divider  component="li" />
     </Fragment>))}
    </List>
          )}
         </Fragment> 
        :
        <Card className='box' sx={{ borderRadius: '9px', height: '100%', margin: 1}}>

          <Typography my={3} px={4} sx={{textAlign: 'center'}} variant="body2" color="text.secondary">
          {isBankWallet(coin) ?
          `Kindly make payment to our ${coin.coin_name} account using the details below`
          : 
          `Enter the USD amount you are sending. We will show how much ${coin.coin_name} to send to the address below.`
          }
          
          </Typography>

          <CardContent sx={{ textAlign: 'center', px: 2, pt: 2, pb: 2 }}>
          <Stack spacing={3} alignItems="center" sx={{ width: '100%' }}>

          {isCryptoWallet(coin) && address && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                maxWidth: 220,
                mx: 'auto',
                py: 1,
                lineHeight: 0,
                '& canvas': {
                  display: 'block',
                  maxWidth: '100%',
                  height: 'auto',
                },
              }}
            >
              <QRCode
                qrStyle="dots"
                value={String(address)}
                size={170}
                quietZone={8}
              />
            </Box>
          )}

          <Box sx={{ width: '100%' }}>
          <CopyToClipboard onCopy={() => {setbuttonText( isBankWallet(coin) ? 'Account Details Copied' : 'Address Copied');
              setTimeout(() => {
                  setbuttonText(null);
              }, 2000);}} text={address}>
              <FormControl fullWidth sx={{ minWidth: 50 }}>
                  <TextField
                  minRows={1}
                  multiline
                  fullWidth
                  defaultValue={address}
                  id="address"
                  name="address"
                  type={'text'}
                  label= {buttonText !== null? buttonText: `Click to copy ${coin.coin_name} ${isBankWallet(coin) ? 'bank details' : 'address'} `}
                  />
              </FormControl> 
          </CopyToClipboard>
          </Box>

          <FormControl fullWidth sx={{ minWidth: 50, width: '100%' }}>
              <InputLabel htmlFor="amount">Amount (USD)</InputLabel>
              {(error !== '' && error.amount) ?

              <OutlinedInput
              onChange={(e)=>setAmount(e.target.value)}
              error
              id="amount"
              type={'number'}
              name="amount"
              label={`Amount (USD)`}
              helperText={error.amount}
              />
              :
              <OutlinedInput
              onChange={(e)=>setAmount(e.target.value)}
              id="amount"
              type={'number'}
              name="amount"
              label="Amount (USD)"
              />
              }
              <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
              {error !== '' && error.amount}
              </Typography>
          </FormControl>

          {!isBankWallet(coin) && usdAmount > 0 && (
            <Box
              sx={{
                mb: 2,
                p: 2,
                borderRadius: 2,
                bgcolor: 'action.hover',
                border: 1,
                borderColor: 'divider',
                textAlign: 'left',
              }}
            >
              {coinPriceUsd > 0 ? (
                <>
                  <Typography variant="body2" color="text.secondary" gutterBottom>
                    You will send approximately
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 700, color: 'primary.main' }}>
                    {formatCryptoAmount(estimatedCoinAmount)} {selectedSymbol}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>
                    {formatUsd(usdAmount)} USD @ {formatUsd(coinPriceUsd)} per {selectedSymbol}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
                    Send this amount to the address above. Your balance is credited in {selectedSymbol} after admin approval.
                  </Typography>
                </>
              ) : (
                <Typography variant="caption" color="warning.main">
                  Price for {selectedSymbol} is not available yet. Try again shortly.
                </Typography>
              )}
            </Box>
          )}

          </Stack>
          </CardContent>

          <CardActions> 
          <Button onClick={()=>setCoin('')} fullWidth={true} edge="end" size="small" color="error" variant="contained"> 
          Cancel
        </Button> 

        <Button onClick={postRequest} fullWidth={true} edge="end" size="small" color="primary" variant="contained"> 
         {isSendingRequest? 'sending...' : 'Confirm Payment'} 
        </Button>

          </CardActions>
        </Card>
        
        }
    </div>
  )
}

export default Receive
